import { IVariablesStore } from '../../store/variablesStore';
import {
  commonCmpOrder,
  ConditionCmp,
  mapVarTypeToConditionCmp
} from '../../condition';

import { IConditionSwitchParams } from './client';
import { ExprKind } from './server';

export const getCmpOrderByExprKind = (
  params: IConditionSwitchParams,
  variablesStore: IVariablesStore
): ConditionCmp[] => {
  if (params.data.kind === ExprKind.CHANNEL || params.data.expr === null) {
    return commonCmpOrder;
  }

  if (
    params.data.kind === ExprKind.EXPR ||
    params.data.kind === ExprKind.MESSAGE
  ) {
    return [...commonCmpOrder, ConditionCmp.LIKE];
  }

  const varItem = variablesStore.getVariableByKey(params.data.expr);

  return varItem ? mapVarTypeToConditionCmp[varItem.type] : commonCmpOrder;
};
